import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENExportType} from '../../enums';


export class SOPutExportProject {

  constructor(
    public uid: string,
    public reasonForExport: string = null,
    public exportType: ENExportType = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutExportProject(
      'uid' in params ? params.uid : null,
      'reasonForExport' in params ? params.reasonForExport : null,
      'exportType' in params ? params.exportType : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
